import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  failureGetUsers,
  successGetUsers,
} from "./UsersSlicer";
import {
  failureCreateUser,
  successCreateUser,
} from "./UsersCreateSlicer";
import {
  AdminUpdateUserPayload,
  failureUpdateUser,
  successUpdateUser,
} from "./UsersUpdateSlicer";
import {
  failureDeleteUser,
  successDeleteUser,
} from "./UsersDeleteSlice";

export interface AdminCreateUserPayload {
  name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
}

const UsersListApi = () => {
  // Backend mounts users routes at /users
  return api.get("/users");
};

export function* UsersListCall() {
  try {
    const response: AxiosResponse = yield call(UsersListApi);
    yield put(successGetUsers(response.data));
  } catch (error) {
    yield put(failureGetUsers(error));
  }
}

const AdminCreateUserApi = (action: PayloadAction<AdminCreateUserPayload>) => {
  return api.post("/users/admin-create", action.payload);
};

export function* AdminCreateUserCall(
  action: PayloadAction<AdminCreateUserPayload>
) {
  try {
    const response: AxiosResponse = yield call(AdminCreateUserApi, action);
    yield put(successCreateUser(response.data));
  } catch (error) {
    yield put(failureCreateUser(error));
  }
}

const UpdateUserApi = (action: PayloadAction<AdminUpdateUserPayload>) => {
  const formData = new FormData();
  formData.append("first_name", action.payload.first_name ?? "");
  formData.append("last_name", action.payload.last_name ?? "");
  formData.append("email", action.payload.email ?? "");
  return api.patch(`/users/${action.payload.id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export function* UpdateUserCall(
  action: PayloadAction<AdminUpdateUserPayload>
) {
  try {
    const response: AxiosResponse = yield call(UpdateUserApi, action);
    yield put(successUpdateUser(response.data));
  } catch (error: any) {
    yield put(failureUpdateUser(error?.response?.data ?? error));
  }
}

const DeleteUserApi = (action: PayloadAction<string>) => {
  return api.delete(`/users/${action.payload}`);
};

export function* DeleteUserCall(action: PayloadAction<string>) {
  try {
    const response: AxiosResponse = yield call(DeleteUserApi, action);
    yield put(successDeleteUser(response.data));
  } catch (error: any) {
    yield put(failureDeleteUser(error?.response?.data ?? error));
  }
}

